import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Wrapper } from "../Dashboard/style";
import WelcomePage from "../../assets/images/WelcomePage.png"; // Import your image

const WelcomeText = styled.h1`
  font-size: 32px;
  font-weight: 600;
  color: #fff;
  margin: 40px 0;
  text-align: center;
  span {
    color: #ed141f; /* Accent color */
  }
`;

// This styled component will make the image fill its parent container
const WelcomeImage = styled.img`
  width: 100%;
  height: 100%;
  margin-top: 1rem;
  object-fit: cover;
`;

const Welcome = () => {
  const { user } = useSelector((state) => state.user);
  const firstName = user?.firstName?.trim();
  const lastName = user?.lastName?.trim();
  const fullName = firstName ? `${firstName}${lastName ? " " + lastName : ""}` : null;
  return (
    <>
      {/* Your original welcome text and image section */}
      <WelcomeText>
        <div>{`Welcome ${fullName || "User"}!`}</div>
      </WelcomeText>

      {/* This section mimics the .payment, .payment-box, and .bottom classes */}

      <WelcomeImage src={WelcomePage} alt="Welcome" style={{ background: "#fff3f4" }} />
    </>
  );
};

export default Welcome;
